/* eslint-disable no-extra-boolean-cast */
/* eslint-disable jsx-a11y/alt-text */
import { Fragment } from "react";
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselDotButton, CarouselItem } from "@/components/ui/carousel";
import { cn } from "@/components/lib/utils";

export function DefaultImageWide() {
  return (
    <div className="bg-gray-100 w-full aspect-video overflow-hidden relative">
      <div className="h-full flex flex-row justify-center items-center">
        <img src="/images/default_image.svg" className="w-[40%] aspect-square" />
      </div>
      <img src="/images/default_image_banner.svg" className="w-full absolute bottom-0 inset-x-0" />
    </div>
  )
}
export function DefaultImageSquare() {
  return (
    <div className="bg-gray-100 w-full aspect-square overflow-hidden relative">
      <div className="h-full flex flex-row justify-center items-center">
        <img src="/images/default_image.svg" className="w-[60%] aspect-square" />
      </div>
      <img src="/images/default_image_banner.svg" className="w-full absolute bottom-0 inset-x-0" />
    </div>
  )
}

export function ImageWideContainer({ image }: { image: string }) {
  return (
    <div className="bg-gray-100 w-full aspect-video overflow-hidden">
      <div className="h-full flex flex-row justify-center items-center">
        <img src={image} className="object-contain" />
      </div>
    </div>
  )
}

export function ImageSquareContainer({ image }: { image: string }) {
  return (
    <div className="bg-gray-100 w-full aspect-square overflow-hidden">
      <div className="h-full flex flex-row justify-center items-center">
        <img src={image} className="object-contain" />
      </div>
    </div>
  )
}

export function ImageCarouselComponent({ data, wide = false, links = [] }: { data: string[], wide?: boolean, links: string[] }) {
  return (
    <Carousel className="my-1" opts={{ loop: true }} plugins={[
      Autoplay({ delay: 3000 })
    ]}>
      <CarouselContent className="mb-1">
        {data.map((image, index) => (
          <CarouselItem key={index} style={{ cursor: links?.[index] ? 'pointer' : 'auto' }}>
            {(links?.[index] && links?.[index] !== '') ?
              <a href={links?.[index]} target="_blank" rel="noreferrer">
                {wide ? <ImageWideContainer image={image} /> : <ImageSquareContainer image={image} />}
              </a>
              : wide ? <ImageWideContainer image={image} /> : <ImageSquareContainer image={image} />
            }

          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselDotButton />
    </Carousel>
  )
}

export function ImageColumn({ data, column = 1, wide = false, links = [] }: { data: string[], column?: number, wide?: boolean, links: string[] }) {
  return (
    <div className={cn("my-2 grid gap-1", column === 3 ? 'grid-cols-3' : column === 2 ? 'grid-cols-2' : 'grid-cols-1')}>
      {data.map((image, index) => (
        <Fragment key={index}>
          <div className="size-full flex flex-row justify-center items-center" style={{ cursor: links?.[index] ? 'pointer' : 'auto' }}>
            {(links?.[index] && links?.[index] !== '') ?
              <a href={links?.[index] ?? ''} target="_blank" rel="noreferrer">
                <img src={image} className={cn("object-fill", wide ? "aspect-video" : "aspect-square")} />
              </a>
              :
              <img src={image} className={cn("object-fill", wide ? "aspect-video" : "aspect-square")} />
            }
          </div>
        </Fragment>
      ))}
    </div>
  )
}

export function ImageScroll({ data, links = [] }: { data: string[], links: string[] }) {
  return (
    <div className="my-2 w-full overflow-x-scroll">
      <div className="mt-2 h-[240px] inline-flex flex-row gap-1">
        {data.map((image, index) => (
          <Fragment key={index}>
            {(links?.[index] && links?.[index] !== '') ?
              <a href={links?.[index] ?? ''} target="_blank" rel="noreferrer" style={{ cursor: links?.[index] ? 'pointer' : 'auto' }}>
                <img src={image} className="h-full aspect-square" />
              </a>
              :
              <img src={image} className="h-full aspect-square" />
            }
          </Fragment>
        ))}
      </div>
    </div>
  )
}